export default theme => ({
  root: {
    marginRight: 0,
    '&.newDesign': {
      marginBottom: 0,
    }
  },
  label: {
    fontSize: 16,
    fontFamily: 'Roboto-Bold',
    letterSpacing: 0,
    '&.regular': {
      fontFamily: 'Roboto-Regular'
    }
  },
  labelError: {
    color: '#f44336'
  },
  asterisk: {
    color: theme.palette.primary.main
  },
  radio: {
    padding: 9,
    color: 'rgba(0, 0, 0, 0.54)',
    '&.newDesign': {
      paddingBottom: 0,
      paddingTop: 0,
    }
  },
  helperTextRoot: {
    marginLeft: 31
  }
})